import {  Switch  } from "@mui/material";

interface TextFieldProps {
  className?: string;
  color?: 'primary' | 'secondary' | 'default';
  id?: string;
  onChange?: (checked: boolean | any, event: any) => void;
  onClick?: (checked: boolean | any, event: any) => void;
  disabled?: boolean;
  children?: any;
  error?: boolean;
  checked?: boolean;
}

export default class EdocatSwitch extends window.React.PureComponent<TextFieldProps, {}> {
  static defaultProps: TextFieldProps = {
    color: 'primary',
    className: '',
    error: false,
    disabled: false,
  };

  render() {
    const { className, onClick, color, id, onChange, checked, disabled } = this.props;
    // @ts-ignore
    return (
      <Switch
        checked={checked}
        className={className}
        color={color}
        disabled={!!disabled}
        id={id}
        onClick={onClick}
        onChange={onChange ? (_event, checked) => onChange(checked, _event) : undefined}
      />
    );
  }
}
